export const EMAIL_PIPELINE_PAGE_PARAM = 'ep_page';
export const EMAIL_PIPELINE_PAGE_SIZE_PARAM = 'ep_page_size';
export const EMAIL_PIPELINE_STATUS_PARAM = 'ep_status';
export const EMAIL_PIPELINE_STORE_PARAM = 'ep_store';
export const EMAIL_PIPELINE_DATE_FROM_PARAM = 'ep_date_from';
export const EMAIL_PIPELINE_DATE_TO_PARAM = 'ep_date_to';
